module.exports = __webpack_public_path__ + "img/carryOver.910b4cdf.png";